/* */ 
'use strict';
var Promise = require('./util/promise'),
    $Ref = require('./ref'),
    Pointer = require('./pointer'),
    parse = require('./parse'),
    debug = require('./util/debug'),
    url = require('./util/url');
module.exports = resolveExternal;
function resolveExternal(parser, options) {
  if (!options.resolve.external) {
    return Promise.resolve();
  }
  try {
    debug('Resolving $ref pointers in %s', parser.$refs._root$Ref.path);
    var promises = crawl(parser.schema, parser.$refs._root$Ref.path + '#', parser.$refs, options);
    return Promise.all(promises);
  } catch (e) {
    return Promise.reject(e);
  }
}
function crawl(obj, path, $refs, options) {
  var promises = [];
  if (obj && typeof obj === 'object') {
    if ($Ref.isExternal$Ref(obj)) {
      promises.push(resolve$Ref(obj, path, $refs, options));
    } else {
      Object.keys(obj).forEach(function(key) {
        var keyPath = Pointer.join(path, key);
        var value = obj[key];
        if ($Ref.isExternal$Ref(value)) {
          promises.push(resolve$Ref(value, keyPath, $refs, options));
        } else {
          promises = promises.concat(crawl(value, keyPath, $refs, options));
        }
      });
    }
  }
  return promises;
}
function resolve$Ref($ref, path, $refs, options) {
  debug('Resolving $ref pointer "%s" at %s', $ref.$ref, path);
  var resolvedPath = url.resolve(path, $ref.$ref);
  var withoutHash = url.stripHash(resolvedPath);
  $ref = $refs._$refs[withoutHash];
  if ($ref) {
    return Promise.resolve($ref.value);
  }
  return parse(resolvedPath, $refs, options).then(function(result) {
    debug('Resolving $ref pointers in %s', withoutHash);
    var promises = crawl(result, withoutHash + '#', $refs, options);
    return Promise.all(promises);
  });
}
